import { MenuItem } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import PWAContext from '../../context/pwa/PWAContext';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';

const Link = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  margin-top: 15px;
  margin-right: 64px;
  border: none;
  margin-top: 80px;
  outline-style: none;
  position: absolute;
  top: -65px;
  right: 200px;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
  prompt(): Promise<void>;
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}

interface IProps {
  type: 'link' | 'menu';
}

const InstallPWA = (props: IProps) => {
  const { state: pwaState } = useContext(PWAContext);
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState<any>(pwaState.event);
  const [appInstalled, setAppInstalled] = useState(false);

  useEffect(() => {
    setAppInstalled(window.matchMedia('(display-mode: standalone)').matches);
    window.addEventListener('appinstalled', () => {
      setAppInstalled(true);
    });
    if (pwaState.event) {
      setSupportsPWA(true);
      setPromptInstall(pwaState.event);
      setSupportsPWA(true);
    }
  }, [pwaState.event]);

  const onClick = (evt: React.MouseEvent<HTMLElement>) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };
  if (!supportsPWA || appInstalled) {
    return null;
  }
  return (
    <>
      {props.type === 'menu' && <MenuItem onClick={onClick}>Instalar APP</MenuItem>}
      {props.type === 'link' && (
        
        <Link className="link-button" id="setup_button" aria-label="Install app" title="Install app" onClick={onClick}>
          <AddToHomeScreenIcon/>
          Instalar APP
        </Link>
      )}
    </>
  );
};

export default InstallPWA;
